<template>
    <div class="terrestrialWildlife">
      <breadcrumb  class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"
                   :childPathThree="childPathThree" :childNameThree="childNameThree"></breadcrumb>
<!--      <div v-for="(file,fileIndex) in terrestrialWildlife" :key="fileIndex" class="contain">-->
<!--        <h4>怒江州高黎贡山陆生野生动物（脊椎动物）</h4>-->
<!--        <el-link class="link" @click="handDownloadFile(file)"><i class="el-icon-document"></i>{{file.name}}<i class="el-icon-download el-icon&#45;&#45;right"></i> </el-link>-->
<!--      </div>-->
      <div class="terrestrialWildlife-container">
        <h2 class="container-title">{{dataInfo.title}}</h2>
        <div class="container-img">
          <img v-for="item in dataInfo.directoryPictureList" :src="item.url" alt="">
        </div>
        <div class="container-content">{{dataInfo.content}}</div>
        <div class="container-file" v-for="(file,fileIndex) in dataInfo.directoryFileList">
          <span class="text">附件：</span>
          <el-link class="link" @click="handDownloadFile(file)"><i class="el-icon-document"></i>{{file.name}}<i class="el-icon-download el-icon--right"></i> </el-link>
        </div>
      </div>
    </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import {FileDown} from "@/utils/util";
import {getOtherFile} from "@/network/common";
import {getDirectoryByType} from "@/network/gaoligongdirectory/nujiangPrefecture";

/**
 * 怒江州高黎贡山陆生野生动物（脊椎动物）
 */
export default {
  name: "terrestrialWildlife",
  components: {breadcrumb },
  data() {
    return {
      terrestrialWildlife: [],
      pvId: 0,
      type: 'terrestrialWildlife',
      path: '',
      name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      dataInfo: {}

    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'

    })
  },
  created() {
    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
    this.childName = '名录'
    this.childPath = this.$route.path
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      getDirectoryByType(this.type).then(res => {
        // console.log(res)
        if(res.data.code === 0) {
          if(res.data.data!==null) {
            this.dataInfo = res.data.data
          }else {
            // this.$refs.dataForm.resetFields()
          }
        }
      })
    },
    handDownloadFile(row) {
      // console.log(row)
      FileDown(row.bucketName, row.fileName,row.name,).then(res => {})
    },
    getOtherFile(){
      getOtherFile(this.pvId,this.type).then(res=>{
        // console.log(res)
        this.terrestrialWildlife = res.data.data
      })
    },

  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/terrestrialWildlife";

.terrestrialWildlife-container {
  width: 1200px;
  margin: 0 auto;
  min-height: 500px;
  .container-title {
    font-size: 17px;
  }
  .container-img {
    width: 30%;
    height: 30% * 3 / 4 ;
    display: inline-block;
    margin: 10px 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .container-content {
    text-indent: 2em;
    text-align: justify;
    font-size: 15px;
    line-height: 2;
  }
  .container-file {
    text-align: left;
    padding: 16px 0;
    .text {
      font-size: 16px;
    }
    .link {
      font-size: 16px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .terrestrialWildlife-container{
    width: 100%;
    padding: 0 24px;
  }

}
</style>